// Db Samples: record crate for the All Packs tile + the LISTEN player on pack pages.
// Ported from the Claude Design project "Db Samples site additions" (Crate.dc.html, Db Bundle.dc.html).
(function () {
  'use strict';

  var reducedMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var canHover = window.matchMedia ? window.matchMedia('(hover: hover)').matches : true;
  function reducedNow() { return !!(reducedMQ && reducedMQ.matches); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // ---------- Crate ----------
  var WOOD = 'repeating-linear-gradient(178.6deg,rgba(60,30,10,0) 0 .9cqw,rgba(60,30,10,.22) .9cqw 1.05cqw,rgba(60,30,10,0) 1.05cqw 1.7cqw),' +
    'repeating-linear-gradient(181.2deg,rgba(255,220,170,0) 0 .55cqw,rgba(255,220,170,.12) .55cqw .7cqw,rgba(60,30,10,.12) .7cqw .78cqw,rgba(255,220,170,0) .78cqw 1.3cqw),' +
    'linear-gradient(90deg,rgba(0,0,0,.06),rgba(255,230,190,.08) 30%,rgba(0,0,0,.04) 60%,rgba(255,230,190,.06) 85%,rgba(0,0,0,.08))';
  function wall(extra, base, inner) {
    return '<div class="crate-part" style="' + extra + 'background:' + WOOD + ',' + base + ';">' + (inner || '') + '</div>';
  }
  var RAIL = '<div class="crate-rail"></div>';
  var HOLE_SIDE = '<div class="crate-hole" style="width:9cqw;height:2.6cqw;margin-left:-4.5cqw;"></div>';
  var HOLE_FRONT = '<div class="crate-hole" style="width:14cqw;height:3cqw;margin-left:-7cqw;"></div>';

  var JX = [0, .7, -.9, .5, -.4, 1, -.8, .3, -.6];
  var JR = [0, .8, -1.1, .5, -.7, 1.2, -.4, .9, -1];
  var JA = [0, .6, -.4, .9, .2, -.6, .7, -.2, .4];
  var GAPS = [95, 100, 110, 125, 145, 170, 200, 235];

  function Crate(root) {
    var covers = [];
    try { covers = JSON.parse(root.dataset.covers || '[]'); } catch (e) { covers = []; }
    covers = covers.slice(0, 9);
    if (!covers.length) return;
    this.root = root; this.covers = covers; this.n = covers.length;
    this.phase = 'rest'; this.flipped = 0; this.tip = false; this.timers = [];
    this.build();
    this.render();
    var self = this;
    this.idle = setInterval(function () {
      if (self.phase !== 'rest' || reducedNow() || document.hidden) return;
      self.tip = true; self.render();
      setTimeout(function () { self.tip = false; self.render(); }, 420);
    }, 4200);
  }
  Crate.prototype.build = function () {
    var recs = '';
    for (var i = this.n - 1; i >= 0; i--) {
      var c = this.covers[i];
      recs += '<div class="crate-rec" data-i="' + i + '">' +
        '<img src="' + esc(c.src) + '" alt="' + esc(c.name) + '" draggable="false" loading="lazy">' +
        '<div class="crate-rec-glaze"></div><div class="crate-rec-shade"></div>' +
        '<div class="crate-rec-edge" style="background:linear-gradient(rgba(0,0,0,.3),rgba(0,0,0,.3)),url(' + esc(c.src) + ') center top / 100% 5000%"></div>' +
        '</div>';
    }
    this.root.innerHTML =
      '<div class="crate-persp"><div class="crate-stage">' +
        '<div class="crate-part" style="left:-46cqw;top:-30cqw;width:92cqw;height:60cqw;transform:translateZ(2cqw) rotateX(90deg);background:radial-gradient(closest-side,rgba(40,14,2,.42),rgba(40,14,2,0));border:0"></div>' +
        '<div class="crate-part" style="left:-30cqw;top:-16cqw;width:60cqw;height:32cqw;transform:translateZ(2cqw) rotateX(90deg);background:#2f1b10;border:0"></div>' +
        wall('left:-30cqw;top:-11cqw;width:60cqw;height:11cqw;transform:translateZ(-14cqw);', '#8a5a30') +
        wall('left:-16cqw;top:-11cqw;width:32cqw;height:11cqw;transform:translateX(-30cqw) translateZ(2cqw) rotateY(90deg);', '#a06a3a', RAIL + HOLE_SIDE) +
        wall('left:-16cqw;top:-11cqw;width:32cqw;height:1.8cqw;transform-origin:50% 0;transform:translateX(-30cqw) translateZ(2cqw) rotateY(-90deg) rotateX(-90deg);border-width:max(1px,.25cqw);', '#c08650') +
        wall('left:-16cqw;top:-11cqw;width:32cqw;height:11cqw;transform:translateX(30cqw) translateZ(2cqw) rotateY(90deg);', '#a06a3a', RAIL + HOLE_SIDE) +
        wall('left:-16cqw;top:-11cqw;width:32cqw;height:1.8cqw;transform-origin:50% 0;transform:translateX(30cqw) translateZ(2cqw) rotateY(90deg) rotateX(-90deg);border-width:max(1px,.25cqw);', '#c08650') +
        recs +
        wall('left:-30cqw;top:-11cqw;width:60cqw;height:11cqw;transform:translateZ(18cqw);', '#c08650',
          RAIL + '<div class="crate-post" style="left:3cqw"></div><div class="crate-post" style="right:3cqw"></div>' + HOLE_FRONT) +
        wall('left:-30cqw;top:-11cqw;width:60cqw;height:1.8cqw;transform-origin:50% 0;transform:translateZ(18cqw) rotateX(-90deg);border-width:max(1px,.25cqw);', '#c08650') +
      '</div></div>' +
      '<div class="crate-ticker" aria-live="polite"></div>';
    this.recEls = [];
    var els = this.root.querySelectorAll('.crate-rec');
    for (var k = 0; k < els.length; k++) this.recEls[+els[k].dataset.i] = els[k];
    this.tickerEl = this.root.querySelector('.crate-ticker');
  };
  Crate.prototype.label = function (k) { return (k + 1) + ' / ' + this.n + ' · ' + this.covers[k].name; };
  Crate.prototype.later = function (fn, ms) { this.timers.push(setTimeout(fn, ms)); };
  Crate.prototype.clear = function () { this.timers.forEach(clearTimeout); this.timers = []; };
  Crate.prototype.ticker = function (text, on) {
    if (text != null) this.tickerEl.textContent = text;
    this.tickerEl.style.opacity = on ? 1 : 0;
  };
  Crate.prototype.play = function (thenRest) {
    var self = this;
    this.clear();
    if (reducedNow()) return;
    this.phase = 'dig'; this.flipped = 0; this.tip = false; this.render(); this.ticker(this.label(0), true);
    var t = 120;
    GAPS.slice(0, this.n - 1).forEach(function (g, idx) {
      t += g; var k = idx + 1;
      self.later(function () { self.flipped = k; self.render(); self.ticker(self.label(k), true); }, t);
    });
    this.later(function () { self.phase = 'fan'; self.flipped = 0; self.render(); self.ticker(self.label(0), true); }, t + 260);
    this.later(function () { self.ticker(null, false); }, t + 1100);
    if (thenRest) this.later(function () { self.phase = 'rest'; self.render(); }, t + 2000);
  };
  Crate.prototype.reset = function () {
    this.clear(); this.phase = 'rest'; this.flipped = 0; this.render(); this.ticker(null, false);
  };
  Crate.prototype.render = function () {
    var reduced = reducedNow();
    var fan = reduced || this.phase === 'fan';
    var front = fan ? 0 : this.flipped;
    for (var i = 0; i < this.n; i++) {
      var el = this.recEls[i];
      var z = 8 - 2 * i, a, rz = JR[i], lift = 0;
      if (fan) {
        a = 8 + i * 1.4; rz = (i % 2 ? 1.4 : -1.4) + JR[i] * .5;
        if (i === 0) { rz = 0; if (!reduced) lift = -3; }
      } else if (i < this.flipped) {
        a = -(42 - .6 * i);
      } else {
        a = 12 + JA[i];
        if (this.tip && i === 0) a = -3;
        if (this.tip && i === 1) a = 6;
      }
      var shade = i < front ? .42 : i === front ? 0 : Math.min(.55, .2 + .05 * (i - front));
      var tr;
      if (reduced) tr = 'none';
      else if (this.phase === 'dig') tr = 'transform 300ms cubic-bezier(.22,.9,.3,1.12)';
      else if (this.phase === 'fan') tr = 'transform 480ms cubic-bezier(.3,.9,.3,1) ' + ((8 - i) * 24) + 'ms';
      else if (this.tip) tr = 'transform 380ms cubic-bezier(.4,0,.3,1)';
      else tr = 'transform 560ms cubic-bezier(.3,.8,.3,1)';
      el.style.transition = tr;
      el.style.transform = 'translate3d(' + JX[i] + 'cqw,' + lift + 'cqw,' + z + 'cqw) rotateX(' + a + 'deg) rotateZ(' + rz + 'deg)';
      el.lastChild.previousSibling.style.opacity = shade;
    }
  };

  document.querySelectorAll('[data-crate]').forEach(function (root) {
    var crate = new Crate(root);
    if (!crate.root) return;
    var tile = root.closest('[data-bundle-tile]') || root;
    var href = root.dataset.href;
    if (canHover) {
      tile.addEventListener('mouseenter', function () { crate.play(false); });
      tile.addEventListener('mouseleave', function () { crate.reset(); });
      if (href) root.addEventListener('click', function () { window.location.href = href; });
    } else {
      // phones: dig once when the crate scrolls into view, tap to dig again
      root.addEventListener('click', function () { crate.play(true); });
      if ('IntersectionObserver' in window) {
        var played = false;
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting && !played) { played = true; crate.play(true); io.disconnect(); }
        }, { threshold: 0.6 });
        io.observe(root);
      }
    }
  });

  // ---------- "get the crate": records float into the cart one by one, the crate poofs, the cart opens ----------
  function addBundle(variantId) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items.some(function (i) { return String(i.variant_id) === String(variantId); })) return;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) });
      }).catch(function (e) { console.error('bundle add failed', e); });
  }
  function openCart() {
    var link = document.querySelector('[data-cart-open]');
    if (link) link.click(); else window.location.href = '/cart';
  }
  document.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
    var busy = false;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (busy) return;
      var adding = addBundle(btn.dataset.bundleAdd);
      var tile = btn.closest('[data-bundle-tile]');
      var crate = tile && tile.querySelector('[data-crate]');
      var cart = document.querySelector('[data-cart-open]');
      var recs = crate ? [].slice.call(crate.querySelectorAll('.crate-rec')).reverse() : []; // front record first
      if (reducedNow() || !document.body.animate || !cart || !recs.length) { adding.then(openCart); return; }
      busy = true;
      var to = cart.getBoundingClientRect();
      if (to.bottom < 0 || to.top > window.innerHeight) to = { left: window.innerWidth - 90, top: 14, width: 60, height: 24 };
      var tx = to.left + to.width / 2, ty = to.top + to.height / 2;
      // start times speed up: each gap is 75% of the one before
      var DUR = 500, SPREAD = 450, R = 0.75, starts = [0];
      var g0 = SPREAD * (1 - R) / (1 - Math.pow(R, recs.length - 1));
      for (var j = 1; j < recs.length; j++) starts.push(starts[j - 1] + g0 * Math.pow(R, j - 1));
      var lastStart = starts[starts.length - 1], end = lastStart + DUR;
      recs.forEach(function (rec, k) {
        var img = rec.querySelector('img');
        setTimeout(function () {
          var r = img.getBoundingClientRect();
          var size = Math.min(r.width, 160);
          var fly = document.createElement('div');
          fly.className = 'crate-fly';
          fly.style.cssText = 'left:' + (r.left + r.width / 2 - size / 2) + 'px;top:' + (r.top + r.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px';
          fly.innerHTML = '<img src="' + esc(img.currentSrc || img.src) + '" alt="">';
          document.body.appendChild(fly);
          rec.style.transition = 'opacity .1s ease';
          rec.style.opacity = '0';
          var dx = tx - (r.left + r.width / 2), dy = ty - (r.top + r.height / 2);
          var tilt = (k % 2 ? 1 : -1) * (4 + k);
          var anim = fly.animate([
            { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 0 },
            { transform: 'translate(0,-24px) scale(.97) rotate(' + (tilt / 3) + 'deg)', opacity: 1, offset: 0.12 },
            { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 110) + 'px) scale(.55) rotate(' + tilt + 'deg)', opacity: 1, offset: 0.58 },
            { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.1) rotate(' + tilt * 1.5 + 'deg)', opacity: 0 }
          ], { duration: DUR, easing: 'cubic-bezier(.4,0,.2,1)' });
          anim.onfinish = function () { fly.remove(); };
        }, starts[k]);
      });
      // the empty crate poofs while the last records are still in the air, and the thank-you rises out of the dust
      setTimeout(function () {
        var cr = crate.getBoundingClientRect();
        var cx = cr.left + cr.width / 2, cy = cr.top + cr.height * 0.66;
        for (var p = 0; p < 16; p++) {
          var puff = document.createElement('div');
          puff.className = 'crate-puff';
          var sz = 20 + Math.random() * 40;
          puff.style.cssText = 'left:' + (cx - sz / 2) + 'px;top:' + (cy - sz / 2) + 'px;width:' + sz + 'px;height:' + sz + 'px';
          document.body.appendChild(puff);
          var ang = (p / 16) * Math.PI * 2 + Math.random() * .4, dist = cr.width * (.16 + Math.random() * .24);
          puff.animate([
            { transform: 'translate(0,0) scale(.3)', opacity: .85 },
            { transform: 'translate(' + Math.cos(ang) * dist + 'px,' + (Math.sin(ang) * dist * .55 - 24) + 'px) scale(1.7)', opacity: 0 }
          ], { duration: 380 + Math.random() * 160, easing: 'cubic-bezier(.15,.75,.3,1)' }).onfinish = (function (el) { return function () { el.remove(); }; })(puff);
        }
        var poof = crate.animate([
          { transform: 'scale(1)', opacity: 1, filter: 'blur(0px)' },
          { transform: 'scale(.15)', opacity: 0, filter: 'blur(5px)' }
        ], { duration: 160, easing: 'cubic-bezier(.55,0,.8,.2)', fill: 'forwards' });
        // slide the copy so the thank-you line lands centered where the crate was (desktop: crate is to the left)
        var copy = tile.querySelector('.bundle-copy'), thanks = tile.querySelector('.bundle-thanks');
        if (copy && thanks && window.matchMedia('(min-width: 601px)').matches) {
          var cb = copy.getBoundingClientRect(), tw = thanks.getBoundingClientRect().width;
          copy.style.setProperty('--slide', Math.round((cr.left + cr.width / 2) - (cb.left + tw / 2)) + 'px');
        } else if (copy) { copy.style.setProperty('--slide', '0px'); }
        tile.classList.add('is-thanked');
        poof.onfinish = function () { recs.forEach(function (rec) { rec.style.transition = 'none'; rec.style.opacity = ''; }); };
      }, lastStart + 100);
      // open the cart once the last record has landed
      setTimeout(function () { adding.then(openCart); }, end + 40);
      // later: the thank-you fades and the full crate fades back in
      setTimeout(function () {
        tile.classList.remove('is-thanked');
        crate.getAnimations().forEach(function (an) { an.cancel(); });
        crate.animate([{ opacity: 0, transform: 'scale(.96)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 400, easing: 'ease-out' })
          .onfinish = function () { recs.forEach(function (rec) { rec.style.transition = ''; }); busy = false; };
      }, end + 1800);
    });
  });

  // ---------- LISTEN player (pack pages) ----------
  document.querySelectorAll('[data-listen]').forEach(function (root) {
    var folders = [];
    try { folders = JSON.parse(root.dataset.folders || '[]'); } catch (e) { folders = []; }
    folders = folders.filter(function (f) { return (f.tracks || []).some(function (t) { return t.src; }); });
    if (!folders.length) { root.hidden = true; return; }
    var base = root.dataset.assetBase || '';
    var audio = new Audio(); audio.preload = 'none';
    var open = 0, playing = null;
    var list = root.querySelector('[data-listen-list]');
    root.querySelector('[data-listen-count]').textContent = folders.length + (folders.length === 1 ? ' folder' : ' folders');

    function src(s) { return /^(https?:)?\/\//.test(s) ? s : base + s; }
    function render() {
      list.innerHTML = folders.map(function (f, fi) {
        var isOpen = fi === open;
        var clips = (f.tracks || []).filter(function (t) { return t.src; });
        var count = f.count != null ? f.count : (f.tracks || []).length;
        var more = count - clips.length;
        var body = '';
        if (isOpen) {
          body = '<div class="listen-clips">' + clips.map(function (t, ti) {
            var id = fi + '-' + ti, on = playing === id;
            return '<button type="button" class="listen-clip' + (on ? ' on' : '') + '" data-clip="' + id + '" data-src="' + esc(t.src) + '" aria-label="' + (on ? 'Pause ' : 'Play ') + esc(t.name) + '">' +
              '<span class="listen-btn" aria-hidden="true">' + (on ? '<i></i><i></i>' : '<b></b>') + '</span>' +
              '<span class="listen-name">' + esc(String(t.name).toLowerCase()) + '</span>' +
              '<span class="listen-meta">' + (t.bpm ? t.bpm + ' bpm' : 'one-shot') + '</span>' +
              '<span class="listen-track"><span class="listen-fill"' + (on ? ' data-fill' : '') + '></span></span>' +
              '</button>';
          }).join('') + (more > 0 ? '<div class="listen-more">+ ' + more + ' more in the pack</div>' : '') + '</div>';
        }
        return '<div class="listen-folder' + (isOpen ? ' open' : '') + '">' +
          '<button type="button" class="listen-head" data-folder="' + fi + '" aria-expanded="' + isOpen + '">' +
          '<span class="listen-fname">' + esc(String(f.name).toLowerCase()) + '</span>' +
          '<span class="listen-count">' + count + '</span><span class="listen-sign">' + (isOpen ? '−' : '+') + '</span></button>' +
          body + '</div>';
      }).join('');
    }
    list.addEventListener('click', function (e) {
      var head = e.target.closest('[data-folder]');
      if (head) { var fi = +head.dataset.folder; open = open === fi ? -1 : fi; render(); return; }
      var clip = e.target.closest('[data-clip]');
      if (!clip) return;
      var id = clip.dataset.clip;
      if (playing === id) { audio.pause(); playing = null; render(); return; }
      audio.src = src(clip.dataset.src);
      audio.play().catch(function () {});
      playing = id; render();
    });
    audio.addEventListener('timeupdate', function () {
      var fill = list.querySelector('[data-fill]');
      if (fill && audio.duration) fill.style.width = (100 * audio.currentTime / audio.duration) + '%';
    });
    audio.addEventListener('ended', function () { playing = null; render(); });
    render();
  });
})();
